module.exports = __webpack_public_path__ + "static/media/area L.42acea35.kra";